module.exports = __webpack_public_path__ + "img/21.6.CODm .3343cfed.png";